import { render, staticRenderFns } from "./singleRoundFinal.vue?vue&type=template&id=3bdbb664&scoped=true"
import script from "./singleRoundFinal.vue?vue&type=script&lang=js"
export * from "./singleRoundFinal.vue?vue&type=script&lang=js"
import style0 from "./singleRoundFinal.vue?vue&type=style&index=0&id=3bdbb664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdbb664",
  null
  
)

export default component.exports